import {Box, Card, CardContent, Grid, Typography, Chip, Divider} from "@mui/material"
import DescriptionIcon from "@mui/icons-material/Description"
import AccessTimeIcon from "@mui/icons-material/AccessTime"
import QueryStatsIcon from "@mui/icons-material/QueryStats"
import {useTranslation} from "react-i18next"
import {TabPanel} from "../../../components/tab-panel-comp"
import WorkingHours from "../../../components/working-hours"

export const TabOverview = ({tabValue, pharmacy}) => {
    const {t} = useTranslation()

    return (
        <TabPanel value={tabValue} index={0} typePanel="pharmacy">
            <Grid container spacing={3}>

                {/* About */}
                <Grid item xs={12}>
                    <Box display="flex" alignItems="center" gap={1} mb={1}>
                        <DescriptionIcon sx={{color: "primary.main"}}/>
                        <Typography variant="h6">{t("About")}</Typography>
                    </Box>
                    <Typography variant="body1" color="text.secondary" paragraph>
                        {pharmacy?.about || t("NoDescriptionAvailable")}
                    </Typography>
                    <Divider/>
                </Grid>

                {/* Business Hours */}
                <Grid item xs={12} md={pharmacy?.workingHours ? 7 : 12}>
                    <Box display="flex" alignItems="center" gap={1} mb={1}>
                        <AccessTimeIcon sx={{color: "primary.main"}}/>
                        <Typography variant="h6">{t("BusinessHours")}</Typography>
                    </Box>
                    {pharmacy?.workingHours ? (
                        <WorkingHours tenant={pharmacy} editable={false}/>
                    ) : (
                        <Card variant="outlined" sx={{p: 3, textAlign: "center"}}>
                            <AccessTimeIcon sx={{fontSize: 40, color: "grey.300", mb: 1}}/>
                            <Typography variant="body2" color="text.secondary">
                                {t("NoWorkingHoursAvailable") || t("SoonAvailable")}
                            </Typography>
                        </Card>
                    )}
                </Grid>

                {/* Key Stats — only shown alongside hours */}
                {pharmacy?.workingHours && (
                    <Grid item xs={12} md={5}>
                        <Box display="flex" alignItems="center" gap={1} mb={1}>
                            <QueryStatsIcon sx={{color: "primary.main"}}/>
                            <Typography variant="h6">{t("KeyStatistics")}</Typography>
                        </Box>
                        <Card variant="outlined">
                            <CardContent>
                                <Grid container spacing={2}>
                                    <Grid item xs={6}>
                                        <Typography variant="body2" color="text.secondary">
                                            {t("TotalProducts")}
                                        </Typography>
                                        <Typography variant="h6">
                                            {pharmacy.totalProducts ?? "—"}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography variant="body2" color="text.secondary">
                                            {t("Categories")}
                                        </Typography>
                                        <Typography variant="h6">
                                            {pharmacy.totalCategories ?? "—"}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>
                )}

                {/* Services */}
                {pharmacy?.services?.length > 0 && (
                    <Grid item xs={12}>
                        <Divider sx={{mb: 2}}/>
                        <Typography variant="h6" gutterBottom>{t("OurServices")}</Typography>
                        <Grid container spacing={1}>
                            {pharmacy.services.map((service, index) => (
                                <Grid item key={index}>
                                    <Chip label={service} color="primary" variant="outlined" size="small"/>
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                )}

                {/* Specializations */}
                {pharmacy?.specializations?.length > 0 && (
                    <Grid item xs={12}>
                        <Typography variant="h6" gutterBottom>{t("Specializations")}</Typography>
                        <Grid container spacing={1}>
                            {pharmacy.specializations.map((spec, index) => (
                                <Grid item key={index}>
                                    <Chip label={spec} color="secondary" variant="outlined" size="small"/>
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                )}
            </Grid>
        </TabPanel>
    )
}
